import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = {
  key: 0,
  class: "p-col-6"
}
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = {
  key: 2,
  class: "p-fluid"
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "kn-material-input-label" }
const _hoisted_16 = {
  key: 3,
  class: "p-fluid"
}
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { class: "kn-material-input-label" }
const _hoisted_19 = {
  key: 4,
  class: "p-fluid"
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_ctx.businessModel)
    ? (_openBlock(), _createBlock(_component_Accordion, {
        key: 0,
        multiple: true,
        activeIndex: [0, 1]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.physicalModel.misc')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metawebBusinessPropertyListTabDescriptor.businessModelInfo, (modelInfo, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "p-col-6",
                    key: index
                  }, [
                    _createVNode("div", _hoisted_2, [
                      _createVNode("label", {
                        for: modelInfo.name,
                        class: "kn-material-input-label"
                      }, _toDisplayString(_ctx.$t(modelInfo.label)), 9, ["for"]),
                      _createVNode(_component_InputText, {
                        class: "kn-material-input",
                        modelValue: _ctx.businessModel[modelInfo.name],
                        "onUpdate:modelValue": ($event: any) => (_ctx.businessModel[modelInfo.name] = $event),
                        id: modelInfo.name,
                        "data-test": "input-name"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "id"])
                    ])
                  ]))
                }), 128)),
                (_ctx.businessModel.physicalTable && _ctx.meta)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('metaweb.businessModel.physicalTable')), 1),
                        _createVNode(_component_InputText, {
                          class: "kn-material-input",
                          modelValue: _ctx.meta.physicalModels[_ctx.businessModel.physicalTable.physicalTableIndex].name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.meta.physicalModels[_ctx.businessModel.physicalTable.physicalTableIndex].name = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.keys(_ctx.categories), (categoryKey, index) => {
            return (_openBlock(), _createBlock(_component_AccordionTab, { key: index }, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(categoryKey), 1)
              ]),
              default: _withCtx(() => [
                _createVNode("div", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories[categoryKey], (prop, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "p-col-6",
                      key: index
                    }, [
                      (prop.propertyType.admissibleValues.length !== 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_7, [
                            _createVNode("div", _hoisted_8, [
                              _createVNode("label", _hoisted_9, _toDisplayString(prop.propertyType.name), 1),
                              _createVNode(_component_Dropdown, {
                                class: "kn-material-input",
                                modelValue: prop.value,
                                "onUpdate:modelValue": ($event: any) => (prop.value = $event),
                                options: prop.propertyType.admissibleValues,
                                onChange: ($event: any) => (_ctx.updateCategoryValue(prop))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (prop.propertyType.admissibleValues.length === 0 && prop.type !== 'structural.attribute' && prop.type !== 'structural.sqlFilter' && prop.type !== 'behavioural.notEnabledRoles')
                        ? (_openBlock(), _createBlock("div", _hoisted_10, [
                            _createVNode("div", _hoisted_11, [
                              _createVNode("label", _hoisted_12, _toDisplayString(prop.propertyType.name), 1),
                              _createVNode(_component_InputText, {
                                class: "kn-material-input",
                                modelValue: prop.value,
                                "onUpdate:modelValue": ($event: any) => (prop.value = $event),
                                disabled: prop.type === 'physical.physicaltable',
                                onChange: ($event: any) => (_ctx.updateCategoryValue(prop))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (prop.type === 'structural.attribute')
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("label", _hoisted_15, _toDisplayString(prop.propertyType.name), 1),
                              _createVNode(_component_Dropdown, {
                                class: "kn-material-input",
                                modelValue: prop.value,
                                "onUpdate:modelValue": ($event: any) => (prop.value = $event),
                                options: _ctx.profileAttributes,
                                onChange: ($event: any) => (_ctx.updateCategoryValue(prop))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (prop.type === 'behavioural.notEnabledRoles')
                        ? (_openBlock(), _createBlock("div", _hoisted_16, [
                            _createVNode("div", _hoisted_17, [
                              _createVNode("label", _hoisted_18, _toDisplayString(prop.propertyType.name), 1),
                              _createVNode(_component_MultiSelect, {
                                class: "kn-material-input",
                                modelValue: prop.value,
                                "onUpdate:modelValue": ($event: any) => (prop.value = $event),
                                options: _ctx.roleOptions,
                                onChange: ($event: any) => (_ctx.updateCategoryValue(prop))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.businessModel.physicalColumn && categoryKey === 'physical')
                        ? (_openBlock(), _createBlock("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, [
                              _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('metaweb.businessModel.physicalColumn')), 1),
                              _createVNode(_component_InputText, {
                                class: "kn-material-input",
                                modelValue: _ctx.businessModel.physicalColumn.name,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.businessModel.physicalColumn.name = $event)),
                                disabled: true
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}